export const environment = {
    production: false,
    apiUrl: "https://dev-api.tim.digitalcloudapps.it",
    authRedirectUrl: "https://dev-report.tim.digitalcloudapps.it/",
    logoutStartUrl: "https://stsoffice365.telecomitalia.it"
};
